import styled from "styled-components";


export const ProductCard = styled.li`

  width: 100%;
  max-width: 12rem;
  max-height: 20rem;
  border-radius: 0.25rem;

  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  padding: 0.5rem 1rem;
  cursor: pointer;

`;

export const MainInfo = styled.div`

  display: flex;
  flex-direction: column;
  gap: 0.5rem;

`;

export const ImageContainer = styled.div`

  position: relative;
  border-radius: 0.25rem;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  input[type="checkbox"] {
    position: absolute;
    top: 0.25rem;
    left: 0.25rem;
    width: 1.25rem;
    height: 1.25rem;

    border: 1px solid #ccc;
    border-radius: 3px;
    cursor: pointer;
    appearance: none;
    display: grid;
    place-content: center;

    background-color: #EDEDED;

    &:checked {
      background-color: #E33AA9;
      border-color: #E33AA9;
    }

    &::after {
      position: relative;
      top: -1px;
      content: "";
      width: 5px;
      height: 10px;
      border-right: 2px solid white;
      border-bottom: 2px solid white;
      transform: rotate(45deg) scale(0);
      transition: transform 0.1s ease-in-out;
    }

    &:checked::after {
      transform: rotate(45deg) scale(1);
    }
  }

`;

export const ProductInfo = styled.div`

  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  padding: 0.5rem 0;

  .name {
    font-weight: 600;
    font-size: 15px;
    color: #333333;

    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
  }

  .upc-and-percentage {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 0.5rem 0;

    p {
      font-size: 0.8rem;
      color: #666666;
    }

    .percentage {
      display: flex;
      align-items: center;
      gap: 0.25rem;

      padding: 0.25rem 0.5rem;
      border-radius: 0.25rem;
      background-color: #e13aa8;

      .icon {
        font-size: 1rem;
      }

      span {
        font-size: 0.85rem;
        // font-weight: 600;
        color: #fff;
      }
    }

  }

  .category-name {
    font-size: 0.75rem;
    color: #999999;
    padding-top: 0.5rem;
    border-top: 1px solid #eeeeee;
  }

`;